import { authHttp } from 'lib/services/http';

export const getInfoServiceIamos = () => {
  return authHttp.get('/users/current/info');
};

export const bulkEmail = (uuids) => {
  return authHttp.post('/users/welcome-email', uuids);
};
